import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { getMarkets } from '../services/MasterDataRepository';
import MBAutocomplete from '../../../shared/components/mbui/MBAutocomplete';

/**
 * @type {React.FC<import("./types").MarketAutocompleteProps>}
 */
const MarketAutocomplete = ({
  index,
  onMarketChange = () => undefined,
  value,
  name = 'market',
  required = false,
  label = 'Market',
}) => {
  const [marketOptions, setMarketOptions] = useState([]);

  useEffect(() => {
    const fetchMarkets = async () => {
      try {
        const markets = await getMarkets();
        const options = markets
          .map((v) => ({
            label: v.name,
            value: v.id,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setMarketOptions(options);
      } catch (error) {
        console.error('Error fetching markets:', error);
      }
    };

    fetchMarkets();
  }, []);

  const onChange = (e, index) => {
    index ? onMarketChange(e, index) : onMarketChange(e);
  };

  return (
    <MBAutocomplete
      options={marketOptions}
      getOptionLabel={(option) =>
        typeof option === 'object' && option !== null
          ? `(${option.value}) ${option.label}`
          : ''
      }
      isOptionEqualToValue={(option, value) => option.value === value.value}
      value={marketOptions.find((option) => option.value === value) || null}
      onChange={(e) => onChange(e, index)}
      renderInput={(params) => (
        <TextField
          {...params}
          name={name}
          size='small'
          placeholder='Select Market'
          required={required}
          label={label}
        />
      )}
    />
  );
};

export default MarketAutocomplete;
